import React from 'react';
import MonacoEditor from 'react-monaco-editor';
import MySqlKeywords from './MySqlKeywords';

export default class MonacoMySql extends React.Component {

    registerAutocomplete(monaco) {
        var new_autocomplete = MySqlKeywords.keywords.map(
            keyword =>
                ({
                    label: keyword,
                    kind: monaco.languages.CompletionItemKind.Keyword,
                    documentation: "Keyword",
                    insertText: keyword
                })
        );
        new_autocomplete = new_autocomplete.concat(MySqlKeywords.operators.map(
            operator =>
                ({
                    label: operator,
                    kind: monaco.languages.CompletionItemKind.Operator,
                    documentation: "Operator",
                    insertText: operator
                })
        ));
        new_autocomplete = new_autocomplete.concat(MySqlKeywords.builtinFunctions.map(
            builtinFunction =>
                ({
                    label: builtinFunction,
                    kind: monaco.languages.CompletionItemKind.Variable,
                    documentation: "Built-in Function",
                    insertText: builtinFunction,
                })
        ))

        if (this.props.autocomplete) {
            new_autocomplete = new_autocomplete.concat(this.props.autocomplete.map(x => {
                switch (x.type) {
                    case 'database': //SHOW DATABASES;
                        return (
                            {
                                label: x.name,
                                kind: monaco.languages.CompletionItemKind.Function,
                                documentation: "`" + x.name + "` Database",
                                insertText: '`' + x.name + '`'
                            });
                    case 'table':
                        return ({
                            label: x.database + '.' + x.name,
                            kind: monaco.languages.CompletionItemKind.Field,
                            documentation: "`" + x.name + "` Table in `" + x.database + "` Database",
                            insertText: '`' + x.database + '`.`' + x.name + '`'
                        });
                    case 'column':
                        return ({
                            label: x.table + '.' + x.name,
                            kind: monaco.languages.CompletionItemKind.Constant,
                            documentation: (x.column_type ? ("Column Type: " + x.column_type + " \n") : "") + "Column `" + x.name + "` in `" + x.table + "` Table in `" + x.database + "` Database",
                            insertText: '`' + x.table + '`.`' + x.name + '`'
                        });
                    default:
                        return ({
                            label: x.name,
                            kind: monaco.languages.CompletionItemKind.Text,
                            documentation: x.type,
                            insertText: x.insert || x.name
                        });
                }
            }));
        }

        return new_autocomplete;
    }

    editorWillMount = (monaco) => {
        monaco.languages.registerCompletionItemProvider('mysql', {
            provideCompletionItems: (model, position) => {
                return {
                    suggestions: this.registerAutocomplete(monaco)
                };
            }
        });
    }

    render() {
        return (
            <MonacoEditor
                ref="editorRef"
                {...this.props}
                options={{
                    ...this.props.options,
                    readOnly: Boolean(this.props.readonly)
                }}
                language="mysql"
                editorWillMount={this.editorWillMount}
            />
        );
    }
}